export default __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-476f9adbc6bc4086a7768de8449e271d.woff2";